















































































































import { Component, Vue } from 'vue-property-decorator';
import Calendar from './Calendar.vue';
import WeeklyCalendar from './WeeklyCalendar.vue';
import GantChart from './GantChart.vue';
import ShiftHeader from './ShiftHeader.vue';
import GSTC from 'gantt-schedule-timeline-calendar';
import { uuid } from 'uuidv4';
import BatchSubmissionModal from '@/components/shift/BatchSubmissionModal.vue';

@Component({
  components: {
    Calendar,
    WeeklyCalendar,
    GantChart,
    ShiftHeader,
    BatchSubmissionModal,
  },
})
export default class ShiftBase extends Vue {
  /**一括提出モーダル表示用フラグ */
  private isOpenBatchSubmissonModal = false;

  private GSTCID = GSTC.api.GSTCID;
  private type: string = 'week';
  private title: string = '';
  private focus: string = '';
  private goToWeeklyView({ date }: { date: string }) {
    this.focus = date;
    this.type = 'week';
  }
  private gotoCertainDate({ date }: { date: string }) {
    this.focus = date;
  }
  // シフトのデータ
  public events: any[] = [1, 2, 3, 4, 5].map((temporaryIndex: number) => {
    const start = new Date();
    start.setDate(temporaryIndex);
    start.setHours(temporaryIndex + 8, 0, 0, 0);
    const end = new Date();
    end.setDate(temporaryIndex);
    end.setHours(temporaryIndex + 8 + temporaryIndex, 0, 0, 0);
    const eventId = uuid();
    return {
      eventId,
      // カレンダービュー用のデータ
      calendar: {
        eventId,
        name: `Shift ${temporaryIndex}`,
        start,
        end,
        color: 'blue',
        timed: true,
        daylyDom: null,
        weeklyDom: null,
      },

      // ガントチャート用のデータ
      gant: {
        eventId,
        id: this.GSTCID(`${temporaryIndex}`),
        label: `Shift ${temporaryIndex}`,
        rowId: this.GSTCID(`${temporaryIndex}`),
        time: {
          start: start.getTime(),
          end: end.getTime(),
        },
        style: { background: '#7fbfff', opacity: '0.7' },
      },
    };
  });
  get eventsForGantChart() {
    return this.events.map((event: any) => event.gant);
  }
  addShift(start: Date, end: Date, rowId?: string) {
    const newEvent = {
      // カレンダービュー用のデータ
      calendar: {
        name: `Shift ${this.events.length + 1}`,
        start,
        end,
        color: 'blue',
        timed: true,
      },

      // ガントチャート用のデータ
      gant: {
        id: `${this.events.length + 1}`,
        label: `Shift ${this.events.length + 1}`,
        rowId: this.GSTCID('1'), // TODO rowIdの扱い
        time: {
          start: start.getTime(),
          end: end.getTime(),
        },
        style: { background: '#7fbfff', opacity: '0.7' },
      },
    };

    return { newEvent, index: this.events.push(newEvent) };
  }
  mounted() {
    this.updateTitle();
  }
  updateTitle() {
    if (this.type === 'month') {
      this.title = (this.$refs.calendar as Calendar).calendarTitle;
    } else if (this.type === 'week') {
      this.title = (this.$refs.weeklyCalendar as WeeklyCalendar).calendarTitle;
    }
  }
  private setToday() {
    // 視点を今日に戻す
    if (this.type === 'month') {
      // console.log((this.$refs.calendar as Calendar))
      (this.$refs.calendar as Calendar).setToday();
    } else if (this.type === 'week') {
      (this.$refs.weeklyCalendar as WeeklyCalendar).setToday();
    }
  }
  private prev() {
    // 視点を次の月(or週)にする
    if (this.type === 'month') {
      // this.title = (this.$refs.calendar as Calendar).getCalendarTitle()
      (this.$refs.calendar as Calendar).prev();
      this.title = (this.$refs.calendar as Calendar).calendarTitle;
    } else if (this.type === 'week') {
      (this.$refs.weeklyCalendar as WeeklyCalendar).prev();
    }
  }
  private next() {
    // 視点を前の月にする
    if (this.type === 'month') {
      // this.title = (this.$refs.calendar as Calendar).getCalendarTitle()
      (this.$refs.calendar as Calendar).next();
      this.title = (this.$refs.calendar as Calendar).calendarTitle;
    } else if (this.type === 'week') {
      (this.$refs.weeklyCalendar as WeeklyCalendar).next();
    }
  }
}
